

import * as turf from '@turf/turf';

// export const getPolygonPoints2 = (coordinates) => {
//   const points = coordinates.map(coord => [parseFloat(coord.longitude), parseFloat(coord.latitude)]);
//   const turfPoints = turf.points(points);
//   const convexHull = turf.convex(turfPoints);
//   if (convexHull) {
//     return convexHull.geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
//   }
//   return null;
// };

// Функция для получения полигона по координатам
export const getPolygonPoints2 = (coordinates, bufferDistance = 20) => {
  const points = coordinates.map(coord => [parseFloat(coord.longitude), parseFloat(coord.latitude)]);
  const turfPoints = turf.points(points);

  // Получаем выпуклую оболочку
  const convexHull = turf.convex(turfPoints);
  
  if (convexHull) {
    // Расширяем полигон с использованием буфера
    const bufferedPolygon = turf.buffer(convexHull, bufferDistance, { units: 'meters' });

    // Возвращаем координаты расширенного полигона
    return bufferedPolygon.geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
  }

  return null;
};

// определение START-END для линии(ПРИ СОЗДАНИИ)
export const updateWithClosestHouse = (points, housesData, maxDistance = 7) => {
  if (!Array.isArray(points) || points.length === 0) return points;

  const findClosest = (point) => {
    const turfPoint = turf.point([point.latLng.lng, point.latLng.lat]);
    let closest = null;
    let minDist = Infinity;

    housesData.forEach(coord => {
      const coordPoint = turf.point([parseFloat(coord.longitude), parseFloat(coord.latitude)]);
      const dist = turf.distance(turfPoint, coordPoint, { units: 'meters' });

      if (dist < maxDistance && dist < minDist) {
        minDist = dist;
        closest = coord;
      }
    });

    return closest;
  };

  return points.map((point, index) => {
    const isFirst = index === 0;
    const isLast = index === points.length - 1;

    if (!isFirst && !isLast) return point;

    const closest = findClosest(point);
    return {
      ...point,
      hid: closest?.hid || null,
      entrance: closest?.entrance || null
    };
  });
};

// Определение START-END для (РЕДАКТИРОВАНИЯ НА КАРТЕ)
export const updateWithEditingClosestHouse = (points, housesData, maxDistance = 7) => {
  if (!Array.isArray(points) || points.length === 0) return points;

  const findClosest = (point) => {
    const turfPoint = turf.point([point.Longitude, point.Latitude]);
    let closest = null;
    let minDist = Infinity;

    housesData.forEach(coord => {
      const coordPoint = turf.point([
        parseFloat(coord.longitude),
        parseFloat(coord.latitude)
      ]);
      const dist = turf.distance(turfPoint, coordPoint, { units: 'meters' });

      if (dist < maxDistance && dist < minDist) {
        minDist = dist;
        closest = coord;
      }
    });

    return closest;
  };

  return points.map((point, index) => {
    const isFirst = index === 0;
    const isLast = index === points.length - 1;

    if (!isFirst && !isLast) return point;

    const closest = findClosest(point);

    return {
      ...point,
      ConnectionHid: closest?.hid ?? null,
      ConnectionEntrance: closest?.entrance ?? null
    };
  });
};
// export const findClosestSwitch = (point, switchesData, maxDistance = 50) => {
//   if (!Array.isArray(switchesData)) return null; // <- защита от undefined или не-массива

//   const turfPoint = turf.point([point.lng, point.lat]);
//   let closest = null;
//   let minDist = Infinity;

//   switchesData.forEach(coordinate => {
//     const coordPoint = turf.point([parseFloat(coordinate.longitude), parseFloat(coordinate.latitude)]);
//     const dist = turf.distance(turfPoint, coordPoint, { units: 'meters' });

//     if (dist < maxDistance && dist < minDist) {
//       minDist = dist;
//       closest = coordinate;
//     }
//   });

//   return closest;
// };

 // определение для линии территории
export const checkPointsInPolygons = (points, markersByCanton, markersByVetka, selectedCanton, housesData) => {
  return points.map(point => {
    const turfPoint = turf.point([point.lng, point.lat]);
    let foundInPolygon = false;
    let polygonInfo = 'вне области полигона';
    let flagTerritory;
    
    Object.keys(markersByCanton).forEach((canton) => {
      const coordinates = markersByCanton[canton];
      const polygonPoints = getPolygonPoints2(coordinates, 20);
      if (polygonPoints) {
        const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
        if (turf.booleanPointInPolygon(turfPoint, polygon)) {
          polygonInfo = `${canton}`;
          foundInPolygon = true;
          flagTerritory = 'canton';
        }
      }
    });

    Object.keys(markersByVetka).forEach((vetka) => {
      const coordinates = markersByVetka[vetka];
      const polygonPoints = getPolygonPoints2(coordinates, 20);
      if (polygonPoints) {
        const polygon = turf.polygon([polygonPoints.map(coord => [coord[1], coord[0]])]);
        if (turf.booleanPointInPolygon(turfPoint, polygon)) {
          polygonInfo = `${vetka}`;
          foundInPolygon = true;
          flagTerritory = 'area';
        }
      }
    });

    if (!foundInPolygon) {
      polygonInfo = selectedCanton;
      flagTerritory = 'city';
    }

     return { ...point, polygonInfo, flagTerritory };
      // 👇 Ищем ближайший дом (switch)
  // const closest = findClosestSwitch(point, housesData, 6); // 6 метров радиус

    // return {
    //   ...point,
    //   polygonInfo,
    //   flagTerritory,
    //   hid: closest?.hid || null,
    //   entrance: closest?.entrance || null
    // };
  });
};



